import { paths } from '@/constants/paths'
import useStore from '@/store/useStore'

export const getMainHomePath = () => {
  const { appConfig } = useStore.getState().common
  const hasHomeTab = appConfig.home?.homeTab
  const hasSpecialHomePage =
    appConfig.specialHome || appConfig.specialHomePageId

  if (hasSpecialHomePage) {
    return paths.SPECIAL_HOME
  } else if (hasHomeTab) {
    return paths.HOME
  } else {
    return paths.CLASSIC_HOME
  }
}
